import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import 'moment/locale/es'

moment.tz.setDefault('America/Santiago');

Vue.use(VueMoment, { moment })